import React, {useEffect, useState} from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";
import WarningNotiifcation from 'components/WarningNotification';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Utils from '../../../utils';

const mt15 = {
    marginTop: 5
}

const isBrowserMt = isBrowser ? mt15 : null;

const formatDate = (data) => {
  const date = new Date(data);
  return Utils.Helpers.convertDate(date);
}

const RelativeCard = ({data}) => {
    const [familyStructure, setFamilyStructure] = useState([]);
    useEffect( () => {
       setFamilyStructure(data);
    }, [data])
    return (
      <>
       {
        familyStructure.length > 0 ? 
        familyStructure.map((element) => {
          return (
            <Card  style={mt15}>
              <Card.Body className={'p-30'}>
                <Row>
                  <Col xs={isBrowser ? 6 : 12}>
                          <Row>
                              <Col xs={isBrowser ? 3 : 12}>
                               <strong> Nombres </strong>
                              </Col>
                              <Col xs={isBrowser ? 9 : 12}>
                                {element.nombre}
                              </Col>
                              <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Apellidos </strong>
                              </Col>
                              <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                {element.apellido}
                              </Col>
                              <Col style={mt15} xs={isBrowser ? 3 : 12}>
                               <strong> Relación </strong>
                              </Col>
                              <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                               { 
                                element.parentescoNombre ? element.parentescoNombre
                                : 'No especificado'
                               }
                              </Col>
                          </Row>
                        </Col>
                  <Col style={!isBrowser ? mt15 : null}  xs={isBrowser ? 6 : 12}>
                            <Row>
                               <Col xs={isBrowser ? 3 : 12}>
                                 <strong> Fecha de nacimiento </strong>
                               </Col>
                               <Col xs={isBrowser ? 9 : 12}>
                                 { 
                                  element.fechaNacimiento ?
                                  formatDate(element.fechaNacimiento)
                                  : 'No especificado' 
                                }
                               </Col>
                               <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                   <strong> Profesión </strong>
                               </Col>
                               <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                 {
                                   element.profesionNombre ?
                                   element.profesionNombre
                                   : 'No especificado'
                                 }
                               </Col>
                               <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                   <strong> Dirección </strong>
                               </Col>
                               <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                 {
                                   element.direccion ?
                                   element.direccion
                                   : 'No especificado'
                                 }
                               </Col>
                               <hr />
                            </Row>
                        </Col>
                </Row>
              </Card.Body>
            </Card>
          ) 
        })
        :
        <Form.Group as={Col} md="12">
          <WarningNotiifcation message='No ha agregado ' enphasis='estructura familiar'/>
        </Form.Group>
       }
      </>
    );
};

export default RelativeCard;